/* eslint-disable jsx-a11y/img-redundant-alt */
import { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Grid, Typography, useMediaQuery, IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ThankyouAutomatedBundleStyles as styleClasses } from './ThankyouAutomatedBundleStyles';
import screenImage from '../../images/Imagen_Final_Screen.png';
import accNumber from '../../images/ICONOO.svg';
import routingNumber from '../../images/RoutingO.svg';
import dateNumber from '../../images/DateImO.svg';
import LeadGenerationContext from '../../context/LeadGenerationContext';
import CustomTooltip from '../Tooltip/CustomTooltip';
import CopyImg from '../../images/copy.svg';
import { commonTernary, openNewAccountTab } from '../commonCode';
import {
  ACCOUNT_NUMBER,
  AHORRA_TISA_EN_URL,
  AHORRA_TISA_ES_URL,
  EN,
  LIBRE_ACCOUNT,
  LIBRE_TISA_EN_URL,
  LIBRE_TISA_ES_URL,
  OPEN_DATE,
  ROUTE_TRANSIT_NUMBER,
  THANKYOUSCREEN_TOOLTIP_CONTENT,
  TOOLTIP_ALTMSG,
  WELCOME_MSG,
} from '../../constants';
import { checkLibrePlus } from '../../services/formService';
import { SavedProductMapping } from '../SaveAndContinue/SavedProductMapping';
import { LibrePlusTypeMapping } from '../../services/LibrePlusTypeMapping';
import {
  CopyIcon,
  DateImageIco,
  InfoWithBGIcon,
  RoutingNumberIcon,
} from '../../images/svg/CustomizedSVG';

const ThankyouAutomatedBundle = () => {
  const { t } = useTranslation();

  const {
    automatedAccDetails,
    language,
    setProductName,
    setCustomerAppId,
    setProductType,
    applicationId,
    accessToken,
    librePlusApiCall,
    setCurrentPage,
    userName,
    theme,
  } = useContext(LeadGenerationContext);

  const [copiedAccNo, setCopiedAccNo] = useState(false);

  useEffect(() => {
    setCurrentPage('thankyou-bundle-automated');
  }, []);

  const handleCopyAccNo = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiedAccNo(true);
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  };

  return (
    <Grid container sx={{ ...styleClasses.mainContainer, background: theme?.customBackground }}>
      <Grid container sx={styleClasses.subContainer}>
        <Box component="span">
          <Box component="img" height="201px" width="205px" src={screenImage} alt="Screen Image" />
        </Box>

        <Typography sx={{ ...styleClasses.welcomeText, color: theme?.palette?.primary?.main }}>
          {`${userName ? `${userName}, ` : ''}${t(WELCOME_MSG, {
            defaultValue: WELCOME_MSG,
          })} 🎉`}
        </Typography>

        <Grid sx={styleClasses.contentContainer}>
          <Grid container sx={styleClasses.contentSubContainer}>
            <Grid sx={styleClasses.accountContainer}>
              <Grid sx={styleClasses.accountSubContainer}>
                <Grid sx={styleClasses.accountTypeContainer}>
                  <Typography sx={styleClasses.accountTypeText1}>
                    {t(LIBRE_ACCOUNT, {
                      defaultValue: LIBRE_ACCOUNT,
                    })}
                  </Typography>
                  <Typography
                    sx={{ ...styleClasses.accountTypeText2, color: theme?.palette?.primary?.main }}
                  >
                    {t('CHECKING ACCOUNT', {
                      defaultValue: 'CHECKING ACCOUNT',
                    })}
                  </Typography>
                </Grid>
                <Grid sx={styleClasses.accountNumContainer}>
                  {/* <Box
                    component="img"
                    src={routingNumber}
                    alt="file-text"
                    sx={styleClasses.accountImg}
                  /> */}
                  <RoutingNumberIcon
                    color={theme?.palette?.orientalPrimary?.main}
                    bgColor={theme?.palette?.iconFillerBg?.main}
                  />
                  <Grid sx={styleClasses.accountGrid}>
                    <Grid sx={styleClasses.accountSubGrid1}>
                      <Typography
                        sx={{
                          ...styleClasses.accountNumberText1,
                          color: theme?.palette?.subtext?.main,
                        }}
                      >
                        {t(ACCOUNT_NUMBER, {
                          defaultValue: ACCOUNT_NUMBER,
                        })}
                      </Typography>
                      <Box component="span" sx={{ padding: '2px' }}>
                        <CustomTooltip
                          placement="bottom-end"
                          text={t(THANKYOUSCREEN_TOOLTIP_CONTENT, {
                            defaultValue: THANKYOUSCREEN_TOOLTIP_CONTENT,
                          })}
                          customAriaLabel={`${t(THANKYOUSCREEN_TOOLTIP_CONTENT, {
                            defaultValue: THANKYOUSCREEN_TOOLTIP_CONTENT,
                          })}`}
                          tabIndex={0}
                        />
                      </Box>
                    </Grid>
                    <Grid sx={styleClasses.accountSubGrid2}>
                      <Typography
                        sx={{
                          ...styleClasses.accountNumberText2,
                          color: theme?.palette?.primary?.main,
                        }}
                      >
                        {automatedAccDetails?.accountNumber?.libre}
                      </Typography>
                      <Box component="span">
                        <IconButton
                          name="copyIcon"
                          aria-label="Copy"
                          onClick={() => handleCopyAccNo(automatedAccDetails?.accountNumber?.libre)}
                          sx={{ padding: '0px' }}
                        >
                          {/* <Box
                            component="img"
                            alt="copy"
                            tabIndex="0"
                            src={CopyImg}
                            width="24px"
                            height="24px"
                          /> */}
                          <CopyIcon color={theme?.palette?.orientalPrimary?.main} />
                        </IconButton>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid sx={styleClasses.accountContainer}>
              <Grid sx={styleClasses.accountSubContainer}>
                <Grid sx={styleClasses.accountTypeContainer}>
                  <Typography sx={styleClasses.accountTypeText1}>
                    {t('Ahorra Account', {
                      defaultValue: 'Ahorra Account',
                    })}
                  </Typography>
                  <Typography sx={styleClasses.accountTypeText2}>
                    {t('SAVINGS ACCOUNT', {
                      defaultValue: 'SAVINGS ACCOUNT',
                    })}
                  </Typography>
                </Grid>
                <Grid sx={styleClasses.accountNumContainer}>
                  {/* <Box
                    component="img"
                    src={routingNumber}
                    alt="file-text"
                    sx={styleClasses.accountImg}
                  /> */}
                  <RoutingNumberIcon
                    color={theme?.palette?.orientalPrimary?.main}
                    bgColor={theme?.palette?.iconFillerBg?.main}
                  />
                  <Grid sx={styleClasses.accountGrid}>
                    <Grid sx={styleClasses.accountSubGrid1}>
                      <Typography
                        sx={{
                          ...styleClasses.accountNumberText1,
                          color: theme?.palette?.subtext?.main,
                        }}
                      >
                        {t(ACCOUNT_NUMBER, {
                          defaultValue: ACCOUNT_NUMBER,
                        })}
                      </Typography>
                      <Box component="span" sx={{ padding: '2px' }}>
                        <CustomTooltip
                          placement="bottom-end"
                          text={t(THANKYOUSCREEN_TOOLTIP_CONTENT, {
                            defaultValue: THANKYOUSCREEN_TOOLTIP_CONTENT,
                          })}
                          customAriaLabel={`${t(THANKYOUSCREEN_TOOLTIP_CONTENT, {
                            defaultValue: THANKYOUSCREEN_TOOLTIP_CONTENT,
                          })}`}
                          tabIndex={0}
                        />
                      </Box>
                    </Grid>
                    <Grid sx={styleClasses.accountSubGrid2}>
                      <Typography
                        sx={{
                          ...styleClasses.accountNumberText2,
                          color: theme?.palette?.primary?.main,
                        }}
                      >
                        {automatedAccDetails?.accountNumber?.ahorra}
                      </Typography>
                      <Box component="span">
                        <IconButton
                          name="copyIcon"
                          aria-label="copy"
                          onClick={() =>
                            handleCopyAccNo(automatedAccDetails?.accountNumber?.ahorra)
                          }
                          sx={{ padding: '0px' }}
                        >
                          {/* <Box
                            component="img"
                            alt="copy"
                            tabIndex="0"
                            src={CopyImg}
                            width="24px"
                            height="24px"
                          /> */}
                          <CopyIcon color={theme?.palette?.orientalPrimary?.main} />
                        </IconButton>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid container sx={styleClasses.contentSubContainer}>
            <Grid sx={styleClasses.contentSubContainerGrid}>
              <Grid sx={styleClasses.accountNumContainer}>
                {/* <Box
                  component="img"
                  src={dateNumber}
                  alt="file-text"
                  sx={{ height: '40px', width: '40px' }}
                /> */}
                <DateImageIco
                  color={theme?.palette?.orientalPrimary?.main}
                  bgColor={theme?.palette?.iconFillerBg?.main}
                />
                <Grid sx={styleClasses.contentSubContainerSubGrid}>
                  <Typography
                    sx={{ ...styleClasses.subGridText1, color: theme?.palette?.subtext?.main }}
                  >
                    {t(OPEN_DATE, {
                      defaultValue: OPEN_DATE,
                    })}
                  </Typography>
                  <Typography
                    sx={{ ...styleClasses.accountTypeText2, color: theme?.palette?.primary?.main }}
                  >
                    {automatedAccDetails?.accountCreatedDate?.replace(/-/g, ' ')}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid sx={styleClasses.contentSubContainerGrid}>
              <Grid sx={styleClasses.accountNumContainer}>
                {/* <Box
                  component="img"
                  src={accNumber}
                  alt="file-text"
                  sx={{ height: '40px', width: '40px' }}
                /> */}
                <InfoWithBGIcon
                  color={theme?.palette?.orientalPrimary?.main}
                  bgColor={theme?.palette?.iconFillerBg?.main}
                />
                <Grid sx={styleClasses.contentSubContainerSubGrid}>
                  <Typography
                    sx={{ ...styleClasses.subGridText1, color: theme?.palette?.subtext?.main }}
                  >
                    {t(ROUTE_TRANSIT_NUMBER, {
                      defaultValue: ROUTE_TRANSIT_NUMBER,
                    })}
                  </Typography>
                  <Typography sx={styleClasses.accountTypeText2}>221571415</Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid sx={styleClasses.buttonContainer}>
          <Typography
            sx={{ ...styleClasses.buttonContainerText, color: theme?.palette?.subtext?.main }}
          >
            {t('View your new account details in Online Banking.', {
              defaultValue: 'View your new account details in Online Banking.',
            })}
          </Typography>
          <Button
            disableFocusRipple
            color="secondary"
            data-testid="openAccTab_id"
            sx={{
              ...styleClasses.bankingButton,
              backgroundColor: theme?.palette?.orientalPrimary?.main,
              '&:hover': {
                backgroundColor: theme?.palette?.orientalPrimary?.main,
              },
              '&:focus': {
                outline: `2px solid ${theme?.palette?.orientalPrimary?.main}`,
                outlineOffset: `2px`,
              },
            }}
            onClick={openNewAccountTab}
            aria-label={`${t('Go to Online Banking', {
              defaultValue: 'Go to Online Banking',
            })} ${'opens in a new tab'}`}
          >
            <Typography sx={styleClasses.bankingButtonText}>
              {t('Go to Online Banking', {
                defaultValue: 'Go to Online Banking',
              })}
            </Typography>
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ThankyouAutomatedBundle;

ThankyouAutomatedBundle.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
};
